﻿Array.prototype.clear = function () {
  this.splice(0, this.length);
};

Array.prototype.add = function (entityToAdd) {
  if (entityToAdd) {
    this.push(entityToAdd);
  }
}

Array.prototype.addRange = function (entitiesToAdd) {
  if (entitiesToAdd) {
    Array.prototype.push.apply(this, entitiesToAdd);
  }
}

Array.prototype.orderByDesc = function (propertySelector) {
  return this.orderBy(propertySelector).reverse();
};

Array.prototype.orderBy = function (propertySelector) {
  let arrayToSendBack = this.copy();
  if (propertySelector) {
    return arrayToSendBack.sort((a, b) => {
      let aProperty = propertySelector(a);
      let bProperty = propertySelector(b);
      if (aProperty > bProperty) {
        return 1;
      } else if (aProperty < bProperty) {
        return -1;
      } else {
        return 0;
      }
    });
  }
  return arrayToSendBack.sort((a, b) => {
    if (a > b) {
      return 1;
    } else if (a < b) {
      return -1;
    } else {
      return 0;
    }
  });
};

Array.prototype.firstOrDefault = function (condition) {
  if (condition) {
    return this.find(condition);
  }
  if (this.length > 0) {
    return this[0];
  }
  return undefined;
};


Array.prototype.lastOrDefault = function (condition) {
  const reversedArray = this.copy().reverse(); //Copy to avoid reversing original array
  return reversedArray.firstOrDefault(condition);
  //this.reverse(); //reverse back again;
  return value;
};


Array.prototype.where = function (condition) {
  return this.filter(condition);
}

Array.prototype.select = function (condition) {
  return this.map(condition);
}
Array.prototype.selectMany = function (condition) {
  let arrays = this.select(condition);
  // let isArray = Array.isArray(arrays.firstOrDefault());
  return arrays.length > 0 ? [].concat(...arrays) : [];
}

Array.prototype.any = function (condition) {
  if (condition === undefined)
    return this.length != 0;
  return this.some(condition);
}

Array.prototype.all = function (condition) {
  if (condition === undefined)
    throw new Error('condition is undefined');
  return this.every(condition);
}

//returns an array with objects of type {key: <grouped value>, values: [<array of elements>]}
Array.prototype.groupBy = function (keySelector, valueSelector) {
  let groups = [];
  valueSelector = valueSelector || ((x) => x);
  for (let i = 0; i < this.length; i++) {
    let currentElement = this[i];
    let currentKey = keySelector(currentElement);
    let group = groups.firstOrDefault(g => g.key === currentKey);
    if (!group) {
      group = { key: currentKey, values: [] };
      groups.add(group);
    }
    group.values.add(valueSelector(currentElement));
  }
  return groups;
}

Array.prototype.copy = function () {
  return this.map(a => a);
}
Array.prototype.contains = function (obj) {
  var i = this.length;
  while (i--) {
    if (this[i] === obj) {
      return true;
    }
  }
  return false;
}

Array.prototype.sum = function (propertySelector) {
  propertySelector = propertySelector || (x => x);
  var returnValue = null;
  for (var element of this) {
    returnValue += propertySelector(element);
  }
  return returnValue;
}

Array.prototype.skip = function (numberOfItemsToSkip) {
  return this.slice(numberOfItemsToSkip);
}

Array.prototype.take = function (numberOfItemsToTake) {
  return this.slice(0, numberOfItemsToTake);
}

Array.prototype.all = function (condition) {
  return this.every(condition);
}

Array.prototype.remove = function (element) {
  const elementIndex = this.indexOf(element);
  if (elementIndex === -1) {
    return;
  }
  this.splice(elementIndex, 1);
}


Array.prototype.intersect = function (array) {
  let t = null;
  let a = this;
  let b = array;
  if (b.length > a.length) {
    t = b;
    b = a;
    a = t; // indexOf to loop over shorter
  }
  return a.filter(function (e) {
      return b.indexOf(e) > -1;
  });
}

Array.prototype.distinct = function () {
  return Array.from(new Set(this));
}

